import React from 'react';

const Phone = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 26" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="Phone_a"
        d="M218.05 346.62c-10.81-5.46-13.6-15.26-14.03-18.88-.43-3.56 5.62-6.74 5.62-6.74l3.84 6.61s-4.08 2.23-3.53 3.5c2.97 6.55 6.92 8.9 6.92 8.9 1.24.51 4.08-2.73 4.08-2.73l5.44 5.28s-4.51 5.97-8.34 4.06"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Phone_a" transform="translate(-204 -321)" />
  </svg>
);

export default Phone;



// WEBPACK FOOTER //
// ./src/common/icons/Phone.js